export enum MatchInteractionTypeEnum {
  Engage = 'ENGAGE',
  Decline = 'DECLINE',
  Undo = 'UNDO',
}
